/**
 * Combines document number and revision for display, e.g. "1034915 - A1".
 * Omits the hyphen and revision when revision is empty or whitespace-only.
 */
export function formatNumberAndRevision(docNo, docRev) {
  const no = docNo == null ? "" : String(docNo).trim();
  const rev = docRev == null ? "" : String(docRev).trim();
  if (!rev) {
    return no || "-";
  }
  if (!no) {
    return rev;
  }
  return `${no} - ${rev}`;
}
